const es = {
    views: {
        home: {
            table: 'Tabla',
            men: 'Hombres',
            women: 'Mujeres',
            users: 'Usuarios',
            usersTotal: 'Total de usuarios:',
            name: 'Nombre',
            email: 'Correo',
        },
    },
};

export default es;
